<!-- Main content starts from here  IIT2-8315-->
<div id="gameDemosContent" [ngClass]="ifStandDwnld ? '': 'content__wrapper'">
    <div id="gameDemosCard" class="card download_std_ipos">
      <div id="gameDemosCardHeader" class="card-header">
        <div id="gameDemosTitle" class="title">{{ifUnisonDemo ? globalconst.UNISON_DEMO_TITLE :globalconst.GAME_DEMO_TITLE}}</div>
      </div>
      <div id="gameDemosCardBody" class="card-body">
        <div id="downloadCardSection" class="download_cards" *ngIf="!ifUnisonDemo">
          <!-- MHR -->
          <div id="MHRDemosMainDiv" class="mainDiv">
            <div id="MHRFirstCard" class="custom-card firstCard p-4">
              <div id="MHRSection" class="d-flex-parent">
                <div id="MHRSubSection" class="d-flex">
                  <div id="downloadImg" class="download_std_image"></div>
                  <div id="detailsContainer" class="details-conatiner">
                    <div id="MHRCustomCardHeader" class="custom-card-header">
                      <div>{{globalconst.MONSTER_HUNTER_SUNBREAK_TITLE}}</div>
                    </div>
                    <div id="MHRsubTxt" class="subtxt">
                      <span>{{globalconst.MONSTER_HUNTER_SUNBREAK_SUBTXT}}</span>
                      <span class="pbt">
                          {{globalconst.MONSTER_HUNTER_SUNBREAK_SUBTXT2}} : {{globalconst.MONSTER_GAME_SIZE}}
                      </span>
                      <div id="gameCollapseBtn" class="collapse_link collapsed collapse-button" type="button"
                      (click)="collpaseExpand('mhr')" i18n="@@game-demos.demos-instructions.read-instructions">Read Instructions
                        <span>
                          <svg class="accordian_expanded" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg" [ngClass]="gameTypes.mhr ? 'transform-180' : ''">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div id="MHRBtnContainer" class="button-container dwnld-btn">
                  <button type="button" class="btn btn-primary" (click)="downloadGames(globalconst.MONSTER_HUNTER_SUNBREAK_VALUE)">{{globalconst.DOWNLOAD}}</button>
                </div>
                <div class="mt-2 text-danger" *ngIf="showMHRErrorMsg">This file cannot be downloaded. Please contact your Intel Representative for more details.</div>
              </div>
            </div>
            <div id="collapseThree" class="collapse logoContentPreview p-4" #collapse="ngbCollapse"
            [(ngbCollapse)]="!gameTypes.mhr" aria-labelledby="logoCGThree">
              <div i18n="@@game-demos.demos-instructions.instruction-note-installation">
                <strong>Note:</strong> The steps below should be carried out before installing IPOS.</div>
              <ol>
                <li>{{globalconst.GAME_DEMOS_MHR_1}}</li>
                <li i18n="@@game-demos.mhr-instructions.instruction-2">Unzip the downloaded game demo zip file. This will create a folder named {{globalconst.GAME_DEMOS_MHR_2}}.</li>
                <li><span i18n="@@game-demos.mhr-instructions.instruction-3">Run {{globalconst.GAME_DEMOS_MHR_3}} from the uncompressed {{globalconst.GAME_DEMOS_MHR_2}} folder.</span></li>
                <li>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_1}}</span><br/>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_2}}</span><br/>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_3}}</span>
                </li>
                <li>{{globalconst.GAME_DEMOS_MHR_5}}</li>
                <li>{{globalconst.GAME_DEMOS_MHR_5_1}}</li>
                <li><span i18n="@@game-demos.mhr-instructions.instruction-ensure-6">To ensure the game runs correctly, launch the game by double-clicking on the {{globalconst.GAME_DEMOS_MHR_7}} in the folder {{globalconst.GAME_DEMOS_MHR_6}}. This will also compile the game shaders.</span></li>
                <li>
                  <span>{{globalconst.GAME_DEMOS_MHR_6_1}}</span><br/>
                  <span>{{globalconst.GAME_DEMOS_MHR_6_2}}</span><br/>
                  <span>{{globalconst.GAME_DEMOS_MHR_6_3}}</span>
                </li>
                <li><span i18n="@@game-demos.mhr-instructions.instruction-running-7_1">If the game does not run correctly, you can uninstall it by running {{globalconst.GAME_DEMOS_MHR_7_1}} from the {{globalconst.GAME_DEMOS_MHR_DEMO}} folder.</span></li>
                <li>{{globalconst.GAME_DEMOS_MHR_8}}</li>
              </ol>
              <span>{{globalconst.GAME_DEMOS_MHR_9}}</span>
            </div>
          </div>
          <!-- CHORUS -->
          <div id="chorusMainDiv" class="mainDiv">
            <div id="chorusFirstCard" class="custom-card firstCard p-4">
              <div id="chorusSection" class="d-flex-parent">
                <div id="chorusSubSection" class="d-flex">
                  <div id="downloadImg2" class="download_std_image2"></div>
                  <div id="chorusDetailContainer" class="details-conatiner">
                    <div id="chorusCardHeader" class="custom-card-header">
                      <div>{{globalconst.CHORUS}}</div>
                    </div>
                    <div id="chrousSubTxt" class="subtxt">
                      <span>{{globalconst.CHORUS_SUBTXT}}</span>
                      <span class="pbt">
                          {{globalconst.MONSTER_HUNTER_SUNBREAK_SUBTXT2}} : {{globalconst.CHORUS_GAME_SIZE}}
                      </span>
                      <div id="chorusCollapseBtn" class="collapse_link collapsed collapse-button" type="button"
                      (click)="collpaseExpand('chorus')" i18n="@@game-demos.demos-instructions.read-instructions"> Read Instructions
                        <span >
                          <svg class="accordian_expanded" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg" [ngClass]="gameTypes.chorus ? 'transform-180' : ''">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div id="chorusBtnContainer" class="button-container dwnld-btn">
                  <button type="button" class="btn btn-primary" (click)="downloadGames(globalconst.CHORUS_VALUE)">{{globalconst.DOWNLOAD}}</button>
                </div>
                <div class="mt-2 text-danger" *ngIf="showChorusErrorMsg">This file cannot be downloaded. Please contact your Intel Representative for more details.</div>
              </div>
            </div>
            <div id="collapseThree" class="collapse logoContentPreview p-4" #collapse="ngbCollapse"
            [(ngbCollapse)]="!gameTypes.chorus" aria-labelledby="logoCGThree">
              <div i18n="@@game-demos.demos-instructions.instruction-note-installation">
                <strong>Note:</strong> The steps below should be carried out before installing IPOS.
              </div>
              <ol>
                <li>{{globalconst.GAME_DEMOS_MHR_1}}</li>
                <li i18n="@@game-demos.chorus-instructions.instruction-2">Unzip the downloaded game demo zip file. This will create a folder named {{globalconst.GAME_DEMOS_CHORUS_2}}.</li>
                <li><span i18n="@@game-demos.chorus-instructions.instruction-3">Run {{globalconst.GAME_DEMOS_CHORUS_3}} from the uncompressed {{globalconst.GAME_DEMOS_CHORUS_2}} folder.</span></li>
                <li>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_1}}</span><br/>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_2}}</span><br/>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_3}}</span>
                </li>
                <li>{{globalconst.GAME_DEMOS_MHR_5}}</li>
                <li>{{globalconst.GAME_DEMOS_MHR_5_1}}</li>
                <li><span i18n="@@game-demos.mhr-instructions.instruction-ensure-6">To ensure the game runs correctly, launch the game by double-clicking on the {{globalconst.GAME_DEMOS_CHORUS_7}} in the folder {{globalconst.GAME_DEMOS_CHORUS_6}}. This will also compile the game shaders.</span></li>
                <li>
                  <span>{{globalconst.GAME_DEMOS_CHORUS_6_1}}</span>
                </li>
                <li><span i18n="@@game-demos.chorus-instructions.instruction-running-7_1">If the game does not run correctly, you can uninstall it by running {{globalconst.GAME_DEMOS_MHR_7_1}} from the {{globalconst.GAME_DEMOS_CHORUS_DEMO}} folder.</span></li>
                <li>{{globalconst.GAME_DEMOS_MHR_8}}</li>
              </ol>
              <span>{{globalconst.GAME_DEMOS_MHR_9}}</span>
            </div>
          </div>
           <!-- SYNCHED -->
           <div id="synchedMainDiv" class="mainDiv">
            <div id="synchedFirstCard" class="custom-card firstCard p-4">
              <div id="synchedSection" class="d-flex-parent">
                <div id="synchedSubSection" class="d-flex">
                  <div id="downloadImg2" class="download_std_image3"></div>
                  <div id="synchedDetailContainer" class="details-conatiner">
                    <div id="synchedCardHeader" class="custom-card-header">
                      <div>{{globalconst.SYNCHED}}</div>
                    </div>
                    <div id="chrousSubTxt" class="subtxt">
                      <span>{{globalconst.SYNCHED_SUBTXT}}</span>
                      <span class="pbt">
                          {{globalconst.MONSTER_HUNTER_SUNBREAK_SUBTXT2}} : {{globalconst.SYNCHED_GAME_SIZE}}
                      </span>
                      <div id="chorusCollapseBtn" class="collapse_link collapsed collapse-button" type="button"
                      (click)="collpaseExpand('synched')" i18n="@@game-demos.demos-instructions.read-instructions"> Read Instructions
                        <span >
                          <svg class="accordian_expanded" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg" [ngClass]="gameTypes.synched ? 'transform-180' : ''">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div id="chorusBtnContainer" class="button-container dwnld-btn">
                  <button type="button" class="btn btn-primary" (click)="downloadGames(globalconst.SYNCHED_VALUE)">{{globalconst.DOWNLOAD}}</button>
                </div>
                <div class="mt-2 text-danger" *ngIf="showChorusErrorMsg">This file cannot be downloaded. Please contact your Intel Representative for more details.</div>
              </div>
            </div>
            <div id="collapseThree" class="collapse logoContentPreview p-4" #collapse="ngbCollapse"
            [(ngbCollapse)]="!gameTypes.synched" aria-labelledby="logoCGThree">
              <div i18n="@@game-demos.demos-instructions.instruction-note-installation">
                <strong>Note:</strong> The steps below should be carried out before installing IPOS.
              </div>
              <ol>
                <li>{{globalconst.GAME_DEMOS_MHR_1}}</li>
                <li i18n="@@game-demos.chorus-instructions.instruction-2">Unzip the downloaded game demo zip file. This will create a folder named {{globalconst.GAME_DEMOS_SYNCHED_2}}.</li>
                <li><span i18n="@@game-demos.chorus-instructions.instruction-3">Run {{globalconst.GAME_DEMOS_SYNCHED_3}} from the uncompressed {{globalconst.GAME_DEMOS_SYNCHED_2}} folder.</span></li>
                <li>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_1}}</span><br/>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_2}}</span><br/>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_3}}</span>
                </li>
                <li>{{globalconst.GAME_DEMOS_MHR_5}}</li>
                <li>{{globalconst.GAME_DEMOS_MHR_5_1}}</li>
                <li><span i18n="@@game-demos.mhr-instructions.instruction-ensure-6">To ensure the game runs correctly, launch the game by double-clicking on the {{globalconst.GAME_DEMOS_SYNCHED_7}} in the folder {{globalconst.GAME_DEMOS_SYNCHED_6}}. This will also compile the game shaders.</span></li>
                <li>
                  <span>{{globalconst.GAME_DEMOS_SYNCED_6_1}}</span>
                </li>
                <li>
                  <span>{{globalconst.GAME_DEMOS_SYNCED_6_2}}</span>
                </li>                
                <li><span i18n="@@game-demos.chorus-instructions.instruction-running-7_1">If the game does not run correctly, you can uninstall it by running {{globalconst.GAME_DEMOS_MHR_7_1}} from the {{globalconst.GAME_DEMOS_SYNCHED_DEMO}} folder.</span></li>
                <li>{{globalconst.GAME_DEMOS_MHR_8}}</li>
              </ol>
              <span>{{globalconst.GAME_DEMOS_MHR_9}}</span>
            </div>
          </div>
          <!-- GhostRunner2 -->
          <div id="GRMainDiv" class="mainDiv">
            <div id="GRFirstCard" class="custom-card firstCard p-4">
              <div id="GRSection" class="d-flex-parent">
                <div id="GRSubSection" class="d-flex">
                  <div id="downloadImg2" class="download_std_image4"></div>
                  <div id="GRDetailContainer" class="details-conatiner">
                    <div id="GRCardHeader" class="custom-card-header">
                      <div>{{globalconst.GR}}</div>
                    </div>
                    <div id="chrousSubTxt" class="subtxt">
                      <span>{{globalconst.GR_SUBTXT}}</span>
                      <span class="pbt">
                          {{globalconst.MONSTER_HUNTER_SUNBREAK_SUBTXT2}} : {{globalconst.GR_GAME_SIZE}}
                      </span>
                      <div id="chorusCollapseBtn" class="collapse_link collapsed collapse-button" type="button"
                      (click)="collpaseExpand('gr')" i18n="@@game-demos.demos-instructions.read-instructions"> Read Instructions
                        <span >
                          <svg class="accordian_expanded" width="22" height="22" viewBox="0 0 24 24" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg" [ngClass]="gameTypes.gr ? 'transform-180' : ''">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div id="chorusBtnContainer" class="button-container dwnld-btn">
                  <button type="button" class="btn btn-primary" (click)="downloadGames(globalconst.GR_VALUE)">{{globalconst.DOWNLOAD}}</button>
                </div>
                <div class="mt-2 text-danger" *ngIf="showChorusErrorMsg">This file cannot be downloaded. Please contact your Intel Representative for more details.</div>
              </div>
            </div>
            <div id="collapseThree" class="collapse logoContentPreview p-4" #collapse="ngbCollapse"
            [(ngbCollapse)]="!gameTypes.gr" aria-labelledby="logoCGThree">
              <div i18n="@@game-demos.demos-instructions.instruction-note-installation">
                <strong>Note:</strong> The steps below should be carried out before installing IPOS.
              </div>
              <ol>
                <li>{{globalconst.GAME_DEMOS_MHR_1}}</li>
                <li i18n="@@game-demos.chorus-instructions.instruction-2">Unzip the downloaded game demo zip file. This will create a folder named {{globalconst.GAME_DEMOS_GR_2}}.</li>
                <li><span i18n="@@game-demos.chorus-instructions.instruction-3">Run {{globalconst.GAME_DEMOS_GR_3}} from the uncompressed {{globalconst.GAME_DEMOS_GR_2}} folder.</span></li>
                <li>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_1}}</span><br/>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_2}}</span><br/>
                  <span>{{globalconst.GAME_DEMOS_MHR_10_3}}</span>
                </li>
                <li>{{globalconst.GAME_DEMOS_MHR_5}}</li>
                <li>{{globalconst.GAME_DEMOS_MHR_5_1}}</li>
                <li><span i18n="@@game-demos.mhr-instructions.instruction-ensure-6">To ensure the game runs correctly, launch the game by double-clicking on the {{globalconst.GAME_DEMOS_GR_7}} in the folder {{globalconst.GAME_DEMOS_GR_6}}. This will also compile the game shaders.</span></li>
                <li>
                  <span>{{globalconst.GAME_DEMOS_GR_6_1}}</span>
                </li>
                <li><span i18n="@@game-demos.chorus-instructions.instruction-running-7_1">If the game does not run correctly, you can uninstall it by running {{globalconst.GAME_DEMOS_MHR_7_1}} from the {{globalconst.GAME_DEMOS_GR_2_DEMO}} folder.</span></li>
                <li>{{globalconst.GAME_DEMOS_MHR_8}}</li>
              </ol>
              <span>{{globalconst.GAME_DEMOS_MHR_9}}</span>
            </div>
          </div>
        </div>
        <div id="unison" class="download_cards" *ngIf="ifUnisonDemo">
          <!-- UNISON -->
          <div id="unisonMainDiv" class="mainDiv">
            <div id="unisonFirstCard" class="custom-card firstCard p-4">
              <div id="unisonSection" class="d-flex-parent">
                <div id="unisonSubSection" class="d-flex">
                  <div id="unisonDownloadImg" class="download_unison_image"></div>
                  <div id="unisonDetailContainer" class="details-conatiner">
                    <div id="unisonCardHeader" class="custom-card-header">
                      <div>{{globalconst.UNISON_GAME_DEMO_HEADING}}</div>
                    </div>
                    <div id="unisonSubTxt" class="subtxt">
                      <span>{{globalconst.UNISON_GAME_DEMO_SUBTXT}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div id="unisonBtnContainer" class="button-container dwnld-btn">
                  <button type="button" class="btn btn-primary"
                    (click)="downloadGames(globalconst.UNISON_VALUE)">{{globalconst.DOWNLOAD}}</button>
                </div>
                
                <div class="mt-2 text-danger" *ngIf="showUnisonErrorMsg" i18n="@@game-demos.download-error.msg">This file cannot be downloaded. Please contact your Intel Representative for more details.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>